type BasedOnParams = { covered: string; total: string; pct: string };

// Local translations
export const T = {
  en_GB: {
    equityStyleGridTitle: "Equity Style Grid",
    equityStyleGridAria: "Equity style grid showing distribution across size and style categories",
    large: "Large",
    mid: "Mid",
    small: "Small",
    value: "Value",
    blend: "Blend",
    growth: "Growth",
    weightLegend: "% Weight Legend:",
    basedOn: (p: BasedOnParams) =>
      `Based on ${p.covered} of ${p.total} products (${p.pct}% of portfolio weight)`,
    missingDataNote: (pct: string) =>
      `This chart covers ${pct}% of the portfolio — analysis data isn't available for the remaining instruments.`,
    snapshotTaken: (time: string) => `Snapshot taken ${time}`,
  },
  nb_NO: {
    equityStyleGridTitle: "Aksjestilrutenett",
    equityStyleGridAria:
      "Aksjestilrutenett som viser fordeling på tvers av størrelses- og stilkategorier",
    large: "Store",
    mid: "Mellom",
    small: "Små",
    value: "Verdi",
    blend: "Blandet",
    growth: "Vekst",
    weightLegend: "% Vektlegende:",
    basedOn: (p: BasedOnParams) =>
      `Basert på ${p.covered} av ${p.total} produkter (${p.pct}% av porteføljevekt)`,
    missingDataNote: (pct: string) =>
      `Dette diagrammet dekker ${pct}% av porteføljen – analysedata er ikke tilgjengelig for de resterende instrumentene.`,
    snapshotTaken: (time: string) => `Øyeblikksbilde tatt ${time}`,
  },
} as const;
